<app-nav-bar-signing-session></app-nav-bar-signing-session>

<main>
  <router-outlet></router-outlet>
  <app-modal-container></app-modal-container>
  <app-internet-check></app-internet-check>
  @if (useAudioVideoConnectionMonitor) {
  <app-audio-video-connection-monitor-v2></app-audio-video-connection-monitor-v2>
  }
</main>
<app-footer></app-footer>
